import {
  types, Instance,
} from 'mobx-state-tree';
import { ItemsArray } from './ItemsArray';
import { FeatureCollection } from 'geojson';
import { EditAction } from '@nebula.gl/edit-modes';
import { PickInfo } from 'deck.gl';
import { MapEditType } from '../../../../components/map/constants';
import getAppRoot from '../../utils/getAppRoot';
import { Coordinates } from '../../models/RootStore.base';
import AnalyticsEvents from '../../../../analytics/analyticsEvents';
import { AnalyticsEventsProps } from '../../../../analytics/analyticsEventsProps';

export type ItemsArrayModelType = Instance<typeof ItemsArray>;

export const props = {
  drawMode: types.optional(types.boolean, false),
  drawnLine: types.optional(types.frozen<FeatureCollection>(), {
    type: 'FeatureCollection',
    features: [],
  }),
  clickCounter: types.optional(types.integer, 0),
  activeDrawEditHandle: types.maybe(types.frozen()),
};

export const views = (self: any) => ({
  get isDrawMode(): boolean {
    return self.drawMode;
  },
});

export const actions = (self: any) => ({
  enterDrawMode() {
    self.drawMode = true;
  },
  exitDrawMode() {
    setTimeout(() => { // required to avoid concurrency with double click zoom disable on the map layer
      self.setDrawMode(false);
    }, 0);
    self.clickCounter = 0;
    self.clearLine();

  },
  trackDrawAnalytics(eventType: AnalyticsEventsProps.Route.DrawRouteEventTpe, routeUuid?: string) {
    getAppRoot(self).account.trackUserForAnalytics(AnalyticsEvents.DRAW_ROUTE, {
      eventType,
      routeId: routeUuid,
    });
  },
  setDrawMode(value: boolean) {
    self.drawMode = value;
  },
  handleDraw({ updatedData, editType }: EditAction<any>) {
    self.drawnLine = updatedData;
    if (editType === MapEditType.ADD_FEATURE) {
      const coordinatesVector: Coordinates[] = updatedData.features[0].geometry.coordinates.map(
        ([longitude, latitude]: [number, number]): Coordinates => ({
          latitude,
          longitude,
        }),
      );
      const routeUuid = getAppRoot(self).mapView.activeRoute?.uuid;
      try {
        getAppRoot(self).model.drawRoute(coordinatesVector, routeUuid);
      } catch (error) {
        console.log(error);
      }
      self.exitDrawMode();
      self.trackDrawAnalytics(AnalyticsEventsProps.Route.DrawRouteEventTpe.SUBMITTED, routeUuid);
    } else if (editType === MapEditType.ADD_TENTATIVE_POSITION) {
      self.clickCounter = self.clickCounter + 1;
    }
  },
  clearLine() {
    self.drawnLine = {
      type: 'FeatureCollection',
      features: [],
    };
  },
  setActiveDrawEditHandle(object: any) {
    self.activeDrawEditHandle = object;
  },
  hoveredDrawEditHandleType(type: MapEditType): boolean {
    return self.activeDrawEditHandle?.properties.editHandleType === type;
  },
  handleHoverDraw(hovered: PickInfo<any>) {
    if (hovered.object) {
      self.setActiveDrawEditHandle(hovered.object);
    }
  },
});
